import { useMemo } from "react";
import { FILE_GUID_REGEX } from "@/hooks/useMarkdownContent";

export const useFileGuids = (content: string) => {
  return useMemo(() => {
    if (!content) return [];
    const matches = [...content.matchAll(FILE_GUID_REGEX)];
    return matches.map((match) => ({
      fileName: match[1] || match[3] || "File",
      guid: match[2],
      fullMatch: match[0],
    }));
  }, [content]);
};
